import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import menu from '../../mocks/menu.json';

// import instagram from '../../../assets/icons/instagram/01.svg';
// import facebook from '../../../assets/icons/facebook/01.svg';
import whatsapp from '../../../assets/icons/social-networks/whatsapp-color.svg';
import { ConfigurationContext } from '../../../shared/context/ConfigurationContext';

import './styles.css';

export default function Index(props) {
    const configuration = useContext(ConfigurationContext);

    const whatsappLink = () => {
        const text = encodeURIComponent(`Hola, solicito información sobre sus productos.`);
        const url = `https://wa.me/${configuration.data.company.whatsapp}?text=${text}`;
        window.open(url, '_blank')
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container">
                <a href="/" className="d-inline-flex link-body-emphasis text-decoration-none">
                    <img src={configuration.data.company.imageUrl} alt="..." style={{ margin: "5px 12px", height: 60 }} />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        {
                            menu.map(item => (
                                <Link key={item.id} to={item.route} style={{ textDecoration: 'none', fontSize: '18px' }}>
                                    <li className="nav-item"><span className="nav-link">{item.name}</span></li>
                                </Link>
                            ))
                        }
                    </ul>
                    {
                        configuration.data.company.whatsapp ?
                            <div className="text-end" style={{ marginRight: 12 }}>
                                <div className='vertical-center button-heeader-ws'>
                                    <a className="text-muted" onClick={whatsappLink} style={{ textDecoration: 'none' }}>
                                        <img src={whatsapp} />&nbsp;
                                        <span>
                                            {configuration.data.company.whatsapp}
                                        </span>
                                    </a>
                                </div>
                            </div> : null
                    }
                    <div className="d-flex">
                        <input
                            className="form-control me-2"
                            type="search"
                            placeholder="Buscar ..."
                            aria-label="Search"
                            onChange={(e) => props.setInputFilter(e.target.value)}
                            onKeyUp={(e) => {
                                e.preventDefault();
                                if (e.keyCode === 13)
                                    props.onSearch(e.target.value);
                            }}
                        />
                        <button className="btn btn-primary" onClick={() => props.onSearch()}>
                            <i className="bi bi-search"></i>
                        </button>
                    </div>
                </div>
            </div>
        </nav>
    );
}